var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewteammembersRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.36,
    cy: 108.3,
    r: 20.9,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.59,103.08a4.23,4.23,0,1,1-4.23-4.23A4.23,4.23,0,0,1,127.59,103.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59,117.76c0-6-3.7-10.83-8.23-10.83s-8.21,4.84-8.23,10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.42,
    y: 87.4,
    width: 11.39,
    height: 11.39,
    rx: 2.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.11,
    y: 89.2,
    width: 2,
    height: 7.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.22,
    y: 92.1,
    width: 7.79,
    height: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.99,
    cy: 356.97,
    r: 20.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.99,
    cy: 351.75,
    r: 4.23,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.22,366.43c0-6-3.7-10.83-8.23-10.83s-8.21,4.84-8.24,10.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.33,349.43l-4.39-2L95.7,349.6a12.85,12.85,0,0,0-4.82-.15l-1.09-2.25-4.51,1.7.66,2.41a13.13,13.13,0,0,0-3.53,3.29l-2.35-.81-2,4.39,2.16,1.24a12.79,12.79,0,0,0-.15,4.81l-2.25,1.1,1.7,4.51,2.41-.66a13,13,0,0,0,3.29,3.52l-.81,2.36,4.39,2,1.24-2.17a12.8,12.8,0,0,0,4.81.16l1.1,2.24,4.51-1.69-.66-2.42a12.76,12.76,0,0,0,3.52-3.28l2.36.81,2-4.39-2.17-1.24a12.85,12.85,0,0,0,.16-4.82l2.24-1.09-1.69-4.51-2.42.66a12.82,12.82,0,0,0-3.29-3.53Zm-2.52,15.51a6.52,6.52,0,1,1-3.24-8.64A6.51,6.51,0,0,1,98.81,364.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.05,333.11l-1.61.79,1.21,3.24,1.74-.47a9.15,9.15,0,0,0,2.36,2.53l-.58,1.69,3.15,1.43.89-1.55a9.39,9.39,0,0,0,3.46.11l.79,1.61,3.24-1.22-.47-1.73a9.45,9.45,0,0,0,2.53-2.36l1.69.58,1.43-3.15-1.56-.89a9.18,9.18,0,0,0,.11-3.46l1.62-.79-1.22-3.24-1.74.47a9.15,9.15,0,0,0-2.36-2.53l.58-1.69-3.15-1.43-.89,1.55a9.39,9.39,0,0,0-3.46-.11L92,320.88l-3.24,1.22.48,1.73a9.16,9.16,0,0,0-2.53,2.36l-1.7-.58-1.43,3.15,1.56.89A9.18,9.18,0,0,0,85.05,333.11Zm11.13-5.69A4.68,4.68,0,1,1,90,329.75,4.69,4.69,0,0,1,96.18,327.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.34,337.45a11,11,0,0,0-.13,4.12l-1.92.94,1.45,3.85,2.06-.56a11,11,0,0,0,2.82,3l-.7,2,3.76,1.7,1.06-1.85a11,11,0,0,0,4.12.13l.93,1.92,3.86-1.45-.56-2.06a11,11,0,0,0,3-2.82l2,.7,1.7-3.76-1.85-1a11,11,0,0,0,.13-4.12l1.92-.94-1.45-3.86-2.06.56a11,11,0,0,0-2.82-3l.7-2-3.76-1.7-1.06,1.85a11,11,0,0,0-4.12-.13L65.52,327l-3.86,1.45.56,2.07a11,11,0,0,0-3,2.81l-2-.69-1.7,3.75Zm13.12-2.67a5.58,5.58,0,1,1-7.39,2.78A5.59,5.59,0,0,1,70.46,334.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.6,301.34a8,8,0,0,1-5.27-13.91,1.93,1.93,0,0,0-1.29-3.38H286.66V259.39l1.35.49a11.64,11.64,0,0,0,4.09.73A11.82,11.82,0,1,0,288,237.7l-1.35.5V214H315a1.94,1.94,0,0,0,1.29-3.38,8,8,0,0,1-2.67-6,7.94,7.94,0,0,1,15.88,0,8,8,0,0,1-2.67,6,1.94,1.94,0,0,0,1.29,3.38h28.55v24.22l-1.34-.5a11.82,11.82,0,1,0,0,22.15l1.34-.5v24.68H328.16a1.93,1.93,0,0,0-1.29,3.38,8,8,0,0,1,2.67,6A8,8,0,0,1,321.6,301.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,284.05l.5-1.35a11.81,11.81,0,1,0-22.88-4.12,11.69,11.69,0,0,0,.73,4.12l.5,1.35H212.7V255.36a1.94,1.94,0,0,0-1.24-1.81,1.89,1.89,0,0,0-.7-.13,1.93,1.93,0,0,0-1.44.64,7.95,7.95,0,1,1,0-10.53,2,2,0,0,0,1.44.64,1.8,1.8,0,0,0,.69-.13,1.94,1.94,0,0,0,1.25-1.81V214h24.21l-.5,1.35a11.81,11.81,0,0,0,11.05,15.9,11.83,11.83,0,0,0,11.1-15.9l-.5-1.35h24.73v28.23a2,2,0,0,0,1.25,1.82,2,2,0,0,0,.69.12,1.94,1.94,0,0,0,1.45-.66,7.95,7.95,0,1,1,0,10.57,1.94,1.94,0,0,0-3.39,1.28v28.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,358l.5-1.35a11.82,11.82,0,1,0-22.16,0L311,358H286.66V329.43a1.94,1.94,0,0,0-1.24-1.81,1.84,1.84,0,0,0-.69-.13,2,2,0,0,0-1.45.64,8,8,0,0,1-6,2.71,7.94,7.94,0,1,1,5.95-13.19,1.94,1.94,0,0,0,1.46.66,1.88,1.88,0,0,0,.66-.12,2,2,0,0,0,1.27-1.82V287.93H311l-.51,1.35a11.82,11.82,0,1,0,22.16,0l-.5-1.35h24.53v28.44a2,2,0,0,0,1.26,1.82,2,2,0,0,0,.68.12,1.93,1.93,0,0,0,1.45-.65,7.94,7.94,0,1,1,6,13.18,8,8,0,0,1-6-2.71,2,2,0,0,0-1.45-.64,1.85,1.85,0,0,0-.7.13,2,2,0,0,0-1.24,1.81V358Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,227.38a7.92,7.92,0,0,1-7.91-7.91,8.05,8.05,0,0,1,2.69-6,1.94,1.94,0,0,0-1.31-3.37H212.7V185.24l1.35.49a11.67,11.67,0,0,0,4.12.74,11.8,11.8,0,1,0-4.12-22.86l-1.35.5V140h28.23a1.94,1.94,0,0,0,1.31-3.38,8.1,8.1,0,0,1-2.69-6,7.93,7.93,0,1,1,13.18,6A1.94,1.94,0,0,0,254,140h28.76v24.07l-1.35-.5a11.8,11.8,0,1,0-4.12,22.86,11.67,11.67,0,0,0,4.12-.74l1.35-.49v24.88H254a2,2,0,0,0-1.82,1.25,2,2,0,0,0,.52,2.14,7.93,7.93,0,0,1-5.27,13.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.07,145.88a2,2,0,0,0-1.63-1.46h-.28a1.93,1.93,0,0,0-1.67,1,8.13,8.13,0,0,1-5.17,4,8.25,8.25,0,0,1-1.91.23A7.92,7.92,0,0,1,302.53,134,8,8,0,0,1,309,135.2a2,2,0,0,0,1.1.34,1.89,1.89,0,0,0,1.1-.35,1.94,1.94,0,0,0,.78-2.05l-6.71-27.28L328.88,100l-.16,1.43a12,12,0,0,0,.26,4.18,11.81,11.81,0,0,0,11.48,9A11.83,11.83,0,0,0,351.94,100a11.79,11.79,0,0,0-1.71-3.83l-.8-1.19,23.82-5.86L380,116.41a2,2,0,0,0,1.64,1.46h.27a1.91,1.91,0,0,0,1.68-1,8,8,0,0,1,5.16-4,7.6,7.6,0,0,1,1.9-.23,7.92,7.92,0,0,1,1.88,15.62,8.18,8.18,0,0,1-1.91.23,8.1,8.1,0,0,1-4.52-1.38,2,2,0,0,0-1.08-.33,1.94,1.94,0,0,0-1.89,2.4l6.9,28-23.83,5.86.17-1.43a11.82,11.82,0,1,0-21.52,5.29l.81,1.19L322,173.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,210.12l.51-1.35a11.68,11.68,0,0,0,.75-4.12,11.82,11.82,0,0,0-23.64,0,11.6,11.6,0,0,0,.75,4.12l.5,1.35H138.74V181.25a1.94,1.94,0,0,0-1.24-1.8,1.86,1.86,0,0,0-.7-.14,2,2,0,0,0-1.43.64,8,8,0,0,1-6,2.65,7.93,7.93,0,1,1,6-13.18,1.93,1.93,0,0,0,1.44.65,2,2,0,0,0,.69-.13,2,2,0,0,0,1.25-1.81V140h24.08l-.5,1.35a11.6,11.6,0,0,0-.75,4.12,11.82,11.82,0,0,0,23.64,0,11.68,11.68,0,0,0-.75-4.12L184,140h24.87v28.09a2,2,0,0,0,1.25,1.81,2,2,0,0,0,.69.13,2,2,0,0,0,1.45-.65,7.94,7.94,0,1,1,6,13.18,8.15,8.15,0,0,1-6-2.65,1.94,1.94,0,0,0-1.43-.63,1.85,1.85,0,0,0-.7.13,1.94,1.94,0,0,0-1.24,1.8v28.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.39,301.34a7.94,7.94,0,0,1-5.24-13.9,1.94,1.94,0,0,0-1.29-3.39H138.74V259.37l1.35.5a11.82,11.82,0,1,0,0-22.15l-1.35.5V214h28.12a1.94,1.94,0,0,0,1.29-3.39,7.94,7.94,0,1,1,13.19-6,8.07,8.07,0,0,1-2.71,6,1.93,1.93,0,0,0,1.29,3.38h28.9v24.22l-1.34-.5a11.82,11.82,0,1,0,0,22.15l1.34-.5v24.68h-28.9a1.94,1.94,0,0,0-1.29,3.38,8.05,8.05,0,0,1,2.71,6A8,8,0,0,1,173.39,301.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,358l.51-1.35a11.68,11.68,0,0,0,.75-4.12,11.82,11.82,0,0,0-23.64,0,11.6,11.6,0,0,0,.75,4.12l.5,1.35H138.74V329.43a1.94,1.94,0,0,0-1.24-1.81,1.89,1.89,0,0,0-.7-.13,1.93,1.93,0,0,0-1.44.64,7.93,7.93,0,1,1-6-13.17,7.85,7.85,0,0,1,6,2.69,1.94,1.94,0,0,0,1.46.66,1.8,1.8,0,0,0,.69-.13,1.94,1.94,0,0,0,1.25-1.81V287.93h24.08l-.5,1.35a11.6,11.6,0,0,0-.75,4.12,11.82,11.82,0,0,0,23.64,0,11.68,11.68,0,0,0-.75-4.12l-.51-1.35h24.87v28.44a2,2,0,0,0,1.26,1.82,2,2,0,0,0,.68.12,1.93,1.93,0,0,0,1.45-.65,7.95,7.95,0,1,1,0,10.47,2,2,0,0,0-1.45-.64,1.85,1.85,0,0,0-.7.13,2,2,0,0,0-1.24,1.81V358Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.46,375.3a7.93,7.93,0,0,1-7.91-7.94,8.14,8.14,0,0,1,2.69-6,1.92,1.92,0,0,0,.5-2.13,1.94,1.94,0,0,0-1.81-1.24H212.7V333.46l1.35.5a11.69,11.69,0,0,0,4.12.76,11.82,11.82,0,1,0-4.12-22.9l-1.35.51v-24.4h28.23a1.94,1.94,0,0,0,1.31-3.38,8,8,0,0,1-2.69-6,7.93,7.93,0,1,1,13.18,6,2,2,0,0,0-.51,2.14,1.93,1.93,0,0,0,1.81,1.25h28.76v24.4l-1.35-.51a11.82,11.82,0,1,0-4.12,22.9,11.64,11.64,0,0,0,4.11-.76l1.36-.5V358H254a1.94,1.94,0,0,0-1.29,3.39,8,8,0,0,1-5.28,13.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.75,
    y: 198.38,
    width: 23.49,
    height: 23.49,
    rx: 5.32,
    transform: "translate(-32.17 14.52) rotate(-9.07)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.44,
    y: 202.09,
    width: 4.12,
    height: 16.06,
    transform: "translate(-32.17 14.52) rotate(-9.07)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.47,
    y: 208.06,
    width: 16.06,
    height: 4.12,
    transform: "translate(-32.19 14.53) rotate(-9.07)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.14,228.25l-4.39-2-1.24,2.16a12.85,12.85,0,0,0-4.82-.15L384.6,226l-4.51,1.7.66,2.41a12.83,12.83,0,0,0-3.53,3.29l-2.35-.81-2,4.39,2.16,1.23a12.85,12.85,0,0,0-.15,4.82l-2.25,1.1,1.7,4.51,2.41-.66a13,13,0,0,0,3.29,3.52l-.81,2.36,4.39,2,1.24-2.17a12.8,12.8,0,0,0,4.81.16l1.1,2.24,4.51-1.7-.66-2.41a12.65,12.65,0,0,0,3.52-3.29l2.36.82,2-4.39-2.17-1.24a12.85,12.85,0,0,0,.16-4.82l2.24-1.09L401,233.47l-2.42.66a12.68,12.68,0,0,0-3.29-3.53Zm-2.52,15.5a6.52,6.52,0,1,1-3.24-8.63A6.51,6.51,0,0,1,393.62,243.75Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-69"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-69",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.85,386.63c0-.32-1.1-32.64-6.34-37.73-5.05-4.91-10.88-.18-11.12,0l-.64-.76c.06-.06,6.76-5.52,12.46,0,5.52,5.37,6.6,37.07,6.64,38.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.3,393c-.15-1.58-3.6-38.87,10.47-55l.75.66c-13.78,15.82-10.26,53.88-10.22,54.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,388.92l-1-.06c0-.44,2.75-43.67-7.52-53.12l.68-.73C343.73,344.77,341.08,387.12,341,388.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.3,388.89h-1c0-1.2.34-29.29,8.35-33.87a5.73,5.73,0,0,1,5.23-.51c4.86,2,7.25,10.62,7.35,11l-1,.27c0-.09-2.37-8.51-6.77-10.33a4.72,4.72,0,0,0-4.35.45C342.63,360.19,342.3,388.61,342.3,388.89Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.2,388.92l-1-.06c0-.22,1.2-22.12-4.7-29.83-1.42-1.84-2.95-2.71-4.56-2.61-3.83.27-7.06,5.9-7.09,6l-.87-.49c.14-.25,3.52-6.16,7.89-6.47,2-.14,3.79.88,5.42,3C340.42,366.42,339.25,388,339.2,388.92Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.32,391.91c-.16-2.13-3.87-52.25,2.67-61.11l.81.6c-6.33,8.55-2.52,59.91-2.48,60.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,359.67s-3.91,1.44-2.75,4.85,13.54,9,13.54,9,5.19-4.75.43-12.48S356.73,357.23,356.62,359.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,359.67s-3.91,1.44-2.75,4.85,13.54,9,13.54,9,5.19-4.75.43-12.48S356.73,357.23,356.62,359.67Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,353.18s4.17-.18,4.41,3.42-9,13.53-9,13.53-6.62-2.39-5.2-11.36S338.57,351,339.6,353.18Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.6,353.18s4.17-.18,4.41,3.42-9,13.53-9,13.53-6.62-2.39-5.2-11.36S338.57,351,339.6,353.18Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.07,336s2.78-.3,2.56-2-10.81-6.05-17.05,1c0,0,4,6.86,9.78,6.95S336.07,336,336.07,336Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.07,336s2.78-.3,2.56-2-10.81-6.05-17.05,1c0,0,4,6.86,9.78,6.95S336.07,336,336.07,336Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25,331.87s-2.51,1.22-3.22-.34,6-10.85,15-8.17c0,0,.24,7.94-4.61,11.07S341.25,331.87,341.25,331.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.25,331.87s-2.51,1.22-3.22-.34,6-10.85,15-8.17c0,0,.24,7.94-4.61,11.07S341.25,331.87,341.25,331.87Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,358.3s1.92-1.55-.15-2.31-12.23-.54-12.33,9.52c0,0,11.83,2,13.29-1.86S328.09,358.3,328.09,358.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.09,358.3s1.92-1.55-.15-2.31-12.23-.54-12.33,9.52c0,0,11.83,2,13.29-1.86S328.09,358.3,328.09,358.3Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,335.73s-1.92-1.55.15-2.31,12.23-.54,12.33,9.52c0,0-11.83,2-13.29-1.86S352.22,335.73,352.22,335.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,335.73s-1.92-1.55.15-2.31,12.23-.54,12.33,9.52c0,0-11.83,2-13.29-1.86S352.22,335.73,352.22,335.73Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,343.83s-.17-1.88,1.35-1.14,6.82,6.45,1.33,11.87c0,0-7.39-5.47-6.06-8.32S346,343.83,346,343.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,343.83s-.17-1.88,1.35-1.14,6.82,6.45,1.33,11.87c0,0-7.39-5.47-6.06-8.32S346,343.83,346,343.83Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38,346.52s1.14-1.51-.53-1.69-9.21,1.82-7.46,9.33c0,0,9.17-.69,9.56-3.81S326.38,346.52,326.38,346.52Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.38,346.52s1.14-1.51-.53-1.69-9.21,1.82-7.46,9.33c0,0,9.17-.69,9.56-3.81S326.38,346.52,326.38,346.52Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.35 416.78 325.89 416.78 322.5 382.34 360.75 382.34 357.35 416.78",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.35 416.78 325.89 416.78 322.5 382.34 360.75 382.34 357.35 416.78",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.82,
    y: 378.54,
    width: 41.61,
    height: 7.6,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.82,
    y: 378.54,
    width: 41.61,
    height: 7.6,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sheets--inject-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "182.99 401.66 182.99 402.78 186.86 404.33 182.99 404.33 182.99 406.97 186.33 406.97 189.86 409.28 187.21 409.28 190.74 411.33 187.21 411.33 187.21 416.58 124.83 416.61 124.83 413.68 122.48 411.33 125.35 411.33 125.35 404.77 120.23 404.77 120.23 402.56 117.69 402.56 117.69 401.66 182.99 401.66",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.99 401.66 182.99 402.78 186.86 404.33 182.99 404.33 182.99 406.97 186.33 406.97 189.86 409.28 187.21 409.28 190.74 411.33 187.21 411.33 187.21 416.58 124.83 416.61 124.83 413.68 122.48 411.33 125.35 411.33 125.35 404.77 120.23 404.77 120.23 402.56 117.69 402.56 117.69 401.66 182.99 401.66",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.99 401.66 182.99 402.78 186.86 404.33 182.99 404.33 182.99 406.97 186.33 406.97 189.86 409.28 187.21 409.28 190.74 411.33 187.21 411.33 187.21 416.58 153.25 416.61 153.25 413.68 150.91 411.33 153.77 411.33 153.77 404.77 148.66 404.77 148.66 402.56 146.11 402.56 146.11 401.66 182.99 401.66",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.35 404.77 153.77 404.77 153.9 406.75 125.35 404.77",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.23 402.56 148.66 402.56 120.23 403.56 120.23 402.56",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "125.35 411.33 153.77 411.33 125.35 410.28 125.35 411.33",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.83 413.68 153.25 413.68 153.25 414.76 124.83 413.68",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.99 402.78 153.77 402.56 182.99 401.9 182.99 402.78",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "182.99 404.33 153.25 404.33 182.99 405.32 182.99 404.33",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.21 409.28 154.21 409.28 154.21 410.28 187.21 409.28",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.21 411.33 163.3 411.33 187.21 411.99 187.21 411.33",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.83 386.96 188.83 388.08 192.7 389.62 188.83 389.62 188.83 392.27 192.17 392.27 195.7 394.57 193.05 394.57 196.58 396.62 193.05 396.62 193.05 401.88 130.67 401.9 130.67 398.97 128.32 396.62 131.19 396.62 131.19 390.06 126.07 390.06 126.07 387.86 123.53 387.86 123.53 386.96 188.83 386.96",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.83 386.96 188.83 388.08 192.7 389.62 188.83 389.62 188.83 392.27 192.17 392.27 195.7 394.57 193.05 394.57 196.58 396.62 193.05 396.62 193.05 401.88 130.67 401.9 130.67 398.97 128.32 396.62 131.19 396.62 131.19 390.06 126.07 390.06 126.07 387.86 123.53 387.86 123.53 386.96 188.83 386.96",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.83 386.96 188.83 388.08 192.7 389.62 188.83 389.62 188.83 392.27 192.17 392.27 195.7 394.57 193.05 394.57 196.58 396.62 193.05 396.62 193.05 401.88 159.09 401.9 159.09 398.97 156.75 396.62 159.61 396.62 159.61 390.06 154.5 390.06 154.5 387.86 151.95 387.86 151.95 386.96 188.83 386.96",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.19 390.06 159.61 390.06 159.74 392.05 131.19 390.06",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.07 387.86 154.5 387.86 126.07 388.85 126.07 387.86",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.19 396.62 159.61 396.62 131.19 395.57 131.19 396.62",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.67 398.97 159.09 398.97 159.09 400.05 130.67 398.97",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.83 388.08 159.61 387.86 188.83 387.2 188.83 388.08",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.83 389.62 159.09 389.62 188.83 390.61 188.83 389.62",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 394.57 160.05 394.57 160.05 395.57 193.05 394.57",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 396.62 169.14 396.62 193.05 397.28 193.05 396.62",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--office-tools--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.53,
    y: 373.79,
    width: 4.61,
    height: 35.06,
    transform: "translate(-56.92 33) rotate(-8.68)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.53,
    y: 373.79,
    width: 4.61,
    height: 35.06,
    transform: "translate(-56.92 33) rotate(-8.68)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 184.05,
    y: 375.06,
    width: 1.31,
    height: 0.36,
    transform: "translate(-54.53 32.18) rotate(-8.68)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 184.21,
    y: 376.1,
    width: 1.31,
    height: 0.36,
    transform: "translate(-54.78 32.29) rotate(-8.7)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 184.37,
    y: 377.14,
    width: 1.31,
    height: 0.37,
    transform: "translate(-54.92 32.31) rotate(-8.7)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 184.53,
    y: 378.18,
    width: 1.31,
    height: 0.36,
    transform: "translate(-55 32.29) rotate(-8.68)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 184.69,
    y: 379.23,
    width: 1.31,
    height: 0.36,
    transform: "translate(-55.15 32.33) rotate(-8.68)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 184.85,
    y: 380.27,
    width: 1.31,
    height: 0.37,
    transform: "translate(-55.29 32.36) rotate(-8.68)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 185.01,
    y: 381.31,
    width: 1.31,
    height: 0.36,
    transform: "translate(-55.46 32.4) rotate(-8.68)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 185.17,
    y: 382.35,
    width: 1.31,
    height: 0.36,
    transform: "translate(-55.63 32.45) rotate(-8.69)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 185.32,
    y: 383.39,
    width: 1.31,
    height: 0.37,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -55.76, 32.46)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 185.48,
    y: 384.44,
    width: 1.31,
    height: 0.36,
    transform: "translate(-56.03 32.57) rotate(-8.7)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 185.64,
    y: 385.48,
    width: 1.31,
    height: 0.36,
    transform: "translate(-56.08 32.54) rotate(-8.68)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 185.8,
    y: 386.52,
    width: 1.31,
    height: 0.37,
    transform: "translate(-56.23 32.57) rotate(-8.68)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 185.96,
    y: 387.56,
    width: 1.31,
    height: 0.36,
    transform: "translate(-56.4 32.62) rotate(-8.68)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 186.12,
    y: 388.6,
    width: 1.31,
    height: 0.36,
    transform: "translate(-56.55 32.65) rotate(-8.68)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 186.28,
    y: 389.64,
    width: 1.31,
    height: 0.37,
    transform: "translate(-56.69 32.68) rotate(-8.68)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 186.44,
    y: 390.69,
    width: 1.31,
    height: 0.36,
    transform: "translate(-56.86 32.72) rotate(-8.68)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 186.6,
    y: 391.73,
    width: 1.31,
    height: 0.36,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -57.12, 32.83)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 186.76,
    y: 392.77,
    width: 1.31,
    height: 0.37,
    transform: "translate(-57.16 32.79) rotate(-8.68)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 186.92,
    y: 393.81,
    width: 1.31,
    height: 0.36,
    transform: "translate(-57.33 32.83) rotate(-8.68)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 187.08,
    y: 394.85,
    width: 1.31,
    height: 0.36,
    transform: "translate(-57.48 32.87) rotate(-8.68)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 187.23,
    y: 395.9,
    width: 1.31,
    height: 0.37,
    transform: "matrix(0.99, -0.15, 0.15, 0.99, -57.63, 32.89)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 187.39,
    y: 396.94,
    width: 1.31,
    height: 0.36,
    transform: "translate(-57.8 32.94) rotate(-8.68)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 187.55,
    y: 397.98,
    width: 1.31,
    height: 0.36,
    transform: "translate(-57.95 32.98) rotate(-8.68)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 187.71,
    y: 399.02,
    width: 1.31,
    height: 0.37,
    transform: "translate(-58.19 33.07) rotate(-8.7)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 193.27,
    y: 379.21,
    width: 1.76,
    height: 23.34,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.88 376.56 193.41 376.56 193.26 379.21 195.03 379.21 194.88 376.56",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "194.88 376.56 193.41 376.56 193.26 379.21 195.03 379.21 194.88 376.56",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 193.27,
    y: 379.21,
    width: 1.76,
    height: 23.34
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 200.99,
    y: 381.65,
    width: 1.55,
    height: 23.6,
    transform: "translate(51.44 -22.38) rotate(7.27)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.81,379.94l-.46-.53.1-3.15-1-.12-1.22,5.46.08,1.18,1.54.19.22-.62-.33,4.15.2,0A44.48,44.48,0,0,0,204.81,379.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.81,379.94l-.46-.53.1-3.15-1-.12-1.22,5.46.08,1.18,1.54.19.22-.62-.33,4.15.2,0A44.48,44.48,0,0,0,204.81,379.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.38 387.3 196.56 387.55 196.74 382.7 200.7 382.5 201.38 387.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.38 387.3 196.56 387.55 197.68 400.64 201.64 400.44 201.38 387.3",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.2 393.96 185.32 393.96 186.75 416.78 201.77 416.78 203.2 393.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.06,
    y: 393.09,
    width: 18.4,
    height: 2.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.06,
    y: 393.09,
    width: 18.4,
    height: 2.33,
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.61,
    y: 197.12,
    width: 95.93,
    height: 95.93,
    transform: "translate(743.16 490.16) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.61,
    y: 197.12,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.42,
    y: 201.93,
    width: 86.31,
    height: 86.3,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.07,260.35c-.57.62-1,1.06-1.51,1.56s-1,.95-1.5,1.4c-1,.92-2,1.8-3.1,2.66a57.68,57.68,0,0,1-6.76,4.7,44.06,44.06,0,0,1-7.64,3.65,30.1,30.1,0,0,1-8.74,1.86l-1.2,0a9.86,9.86,0,0,1-1.87-.17,9.64,9.64,0,0,1-3.36-1.38,13,13,0,0,1-3.84-4.2,28.74,28.74,0,0,1-3-8.24,65,65,0,0,1-1.31-15.85l5.09-.32a98.77,98.77,0,0,0,3.72,14,23.32,23.32,0,0,0,2.83,5.68,3.72,3.72,0,0,0,1.35,1.24c.13,0,.15,0,.15,0s0,0,0,0l.68-.09c3.92-.53,8-2.43,11.81-4.88a61.76,61.76,0,0,0,5.59-4.08c.91-.73,1.8-1.48,2.66-2.27l1.28-1.17,1.17-1.12Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,263.2l5.51,12.2s.58-.19,1.56-.55l2.73-1.05c6.1-2.43,15.93-7.59,18.17-11.53,3.35-5.89-2.32-10.17-12.57-7.93-4.43,1-8.39,4.44-11.39,6.29-1,.61-1.84,1.15-2.5,1.58C340.49,262.82,339.93,263.2,339.93,263.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.59,263c-1.35-2.57-4.91.2-10.8.94-2.62.34-11.66,7-12.41,9.13l1.06,2.35S364.37,268.91,367.59,263Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.46,248.13l1.38-7.71-7.43,1.14s-.14,7.43,2.13,7.94Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.49 234.93 316.53 237.07 318.41 241.56 325.84 240.42 321.49 234.93",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,256.57c-.23.71-.44,1.42-.66,2.14A171.23,171.23,0,0,0,389.55,288l0,.25H350.81c1.36-22.63,7.47-34.19,7.47-34.19s1.42-.31,3.81-.6c1.87-.22,4.22-.44,6.6-.48a136.92,136.92,0,0,1,15.39,1.16c2.68.33,5.39.87,7.55,1.35C394.23,256.05,396,256.57,396,256.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,288a172.13,172.13,0,0,1,5.82-29.27c-2.4-.39-6.56-.46-7.54,3.39C386.78,266.25,387,276.2,389.55,288Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,261.05c.63,1.16,1.16,2.19,1.68,3.29s1,2.19,1.51,3.29c1,2.21,1.86,4.45,2.66,6.74a66.86,66.86,0,0,1,3.46,14.43l.06.48,0,.35,0,.53a6.6,6.6,0,0,1-.12,1.45c0,.15-.05.27-.09.43s-.11.35-.17.52-.12.32-.21.5-.21.38-.32.57a5.86,5.86,0,0,1-.86,1,5.5,5.5,0,0,1-1.09.79,6.42,6.42,0,0,1-1.06.46,8.32,8.32,0,0,1-.91.2,6.88,6.88,0,0,1-2.34-.1,11.9,11.9,0,0,1-2.55-.87c-.69-.32-1.29-.65-1.87-1a55.55,55.55,0,0,1-6.1-4.26,109.67,109.67,0,0,1-10.5-9.56l3.23-4c3.88,2.39,7.8,4.83,11.66,7.07a59.5,59.5,0,0,0,5.69,3,12.47,12.47,0,0,0,1.27.49,2.19,2.19,0,0,0,.75.17s-.1-.08-.61,0a2.16,2.16,0,0,0-.49.11,3.49,3.49,0,0,0-.68.28,3.36,3.36,0,0,0-.73.54,4.22,4.22,0,0,0-.6.7,3.32,3.32,0,0,0-.56,1.8v.1s0,.06,0,0l0-.09-.08-.38a58.84,58.84,0,0,0-1.61-6.12c-.66-2.05-1.41-4.1-2.2-6.15s-1.67-4.07-2.57-6.09-1.88-4.07-2.78-5.92Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,268.22c1.19,4.64,7.87,15.11,7.87,15.11l13.25-2.66s-.13-.58-.37-1.58c-.18-.74-.42-1.73-.72-2.86-1.79-6.69-5.58-18.66-10.11-19.67C389.27,255.05,384,259.8,386.12,268.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.05,236.83l-4.38,3.11-6,4.23a18.13,18.13,0,0,1,.19,2.3c.07,3.06-.92,5.77-5.48,6.49,0,0-5.57,3.12,2.26,4.35a10.76,10.76,0,0,0,.2,2.56,10,10,0,0,1,2.72-2.26c8.63.5,10.07-3.41,10.07-3.41C381.57,250.64,383.53,241.71,385.05,236.83Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.71,244.17a18.13,18.13,0,0,1,.19,2.3c2.12-.27,5.09-2.29,5.54-4.4a9.33,9.33,0,0,0,.23-2.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.82,218.51c-3.45,1.26-6,10.52-1.92,12.86S379.36,216.13,372.82,218.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.28,229.83c-1.92,6.47-2.72,10.35-6.84,13.06a8.78,8.78,0,0,1-13.69-7.37c-.05-6.17,3.11-15.73,10.17-17.07A8.89,8.89,0,0,1,387.28,229.83Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.45,225.39c-1.87,3.45-1,9.16.84,10.27,2,2,6.34-1.3,7.46-3.34,1-1.82,1.86-6.21,1.15-8.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.28,236.81a7.19,7.19,0,0,1-4.36,2.17c-2.1.2-2.43-1.76-1.23-3.54,1.07-1.6,3.46-3.63,5.28-3S389.75,235.3,388.28,236.81Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.85,229.7c-.13.53-.51.91-.87.84s-.53-.56-.41-1.09.51-.91.86-.84S377,229.16,376.85,229.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.77,228.51c-.12.53-.51.91-.86.84s-.54-.56-.41-1.09.51-.91.86-.84S370.89,228,370.77,228.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.64,229.15a20.49,20.49,0,0,1-3.63,4.06,3.13,3.13,0,0,0,2.46,1Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.18,228.12l.16,0a.32.32,0,0,0,.15-.43,3,3,0,0,0-2.27-1.8.31.31,0,0,0-.36.28.31.31,0,0,0,.28.35,2.48,2.48,0,0,1,1.77,1.44A.32.32,0,0,0,379.18,228.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,225.92a.32.32,0,0,0,.28-.12,2.65,2.65,0,0,1,2.11-1.07.33.33,0,1,0,.05-.65h0a3.34,3.34,0,0,0-2.67,1.32.32.32,0,0,0,0,.45A.34.34,0,0,0,368.64,225.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.31,235.44s1.94-.51,7.39-.39c-.67,2-1.88,3.67-4.67,3.58S370.31,235.44,370.31,235.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.35,237.05a4.32,4.32,0,0,0-3.06.92,2.59,2.59,0,0,0,1.74.66,4.28,4.28,0,0,0,3-.93A2.6,2.6,0,0,0,374.35,237.05Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.55,235.39c.15.44.3.88.84,1a23.12,23.12,0,0,0,4.83-.4,1.51,1.51,0,0,0,1.24-1A35.31,35.31,0,0,0,370.55,235.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,259.44h0a1.33,1.33,0,0,0,1.53-1.08l.18-1.07,38.6,6.71-.18,1.07a1.32,1.32,0,0,0,1.08,1.53h0a4,4,0,0,1,3.35,4.11,3.87,3.87,0,0,1-4.51,3.52l-.16,0a1.32,1.32,0,0,0-1.53,1.08l-.19,1.06-38.6-6.7.18-1.07a1.31,1.31,0,0,0-1.07-1.53l-.17,0a3.86,3.86,0,0,1-3.05-4.83A4,4,0,0,1,333.4,259.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.62,262a1.4,1.4,0,1,0,1.48,2.37,1.4,1.4,0,0,0-1.48-2.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.12,
    y: 262.11,
    width: 0.48,
    height: 2.13,
    transform: "translate(285.04 684.46) rotate(-121.96)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.7,271.71a1.4,1.4,0,0,0,1.26-2.49,1.4,1.4,0,1,0-1.26,2.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.09,
    y: 269.4,
    width: 0.48,
    height: 2.13,
    transform: "translate(784.3 57.88) rotate(116.74)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.58,271.08a.65.65,0,0,1-.59-.42c-.5-1.15.2-3.67,1.45-5.2a4.54,4.54,0,0,1,1.1-1,9.9,9.9,0,0,0,.36-2.32,12.83,12.83,0,0,0-2.13,2.07c-1.34,1.48-2.72,3-4,3.07a1.3,1.3,0,0,1-1.3-.72,2,2,0,0,1-.22-1,15.22,15.22,0,0,1-4-.58l.27-.92a13.54,13.54,0,0,0,3.81.54,3.79,3.79,0,0,1,.62-1.36,1.23,1.23,0,0,1,1.25-.59l.3.07c.49.1.87.18,1,.57s-.22.78-1.06,1.58a2.56,2.56,0,0,1-1.25.59,1.25,1.25,0,0,0,.11.62c.06.12.13.22.41.21.87,0,2.23-1.55,3.32-2.76a9.07,9.07,0,0,1,2.75-2.44.72.72,0,0,1,1,.45,5.83,5.83,0,0,1-.14,2.48,2.56,2.56,0,0,1,1,0,20.48,20.48,0,0,0,2.61.36c1.48.13,2.66.24,3.19,1.26a4.66,4.66,0,0,1,1.11-.12c1.6.06,1.81,1.49,1.93,2.26a2.88,2.88,0,0,0,.11.57,8,8,0,0,0,2.5-1.45l.77-.61v2.22h5.92v1h-6.88V268.3a4.85,4.85,0,0,1-2.51,1.08c-.68-.09-.78-.81-.87-1.38-.14-1-.28-1.41-1-1.43a3.19,3.19,0,0,0-.86.09,3.78,3.78,0,0,1-1.86,2.83,1,1,0,0,1-1.41-.35,1.42,1.42,0,0,1,.12-1.47,4.68,4.68,0,0,1,2-1.63c-.33-.42-1-.5-2.35-.62a19.7,19.7,0,0,1-2.73-.38,1.79,1.79,0,0,0-1.06.09c-.65,2.59-1.82,5.6-2.55,5.9A.66.66,0,0,1,346.58,271.08Zm1.48-4.85a6.77,6.77,0,0,0-1.27,3.41A20.35,20.35,0,0,0,348.06,266.23Zm7.55.84a3.47,3.47,0,0,0-1.28,1.1c-.07.12-.19.35-.1.5s.44-.13.87-.69A3,3,0,0,0,355.61,267.07ZM343,263.64s-.12,0-.27.24a2.32,2.32,0,0,0-.31.56,1.28,1.28,0,0,0,.36-.22l.53-.51-.31-.07Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M383.29,277.18l-3-6.18L376,278.38s3.63,5,6,2.91Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.18 269.19 370.89 275.45 375.97 278.38 380.31 271 374.18 269.19",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.68,213.68s1-3.38-1-3.43c-4.4-.11-5.37,9.31-.91,11.18s11.67,0,11.67,0a23.73,23.73,0,0,1,.31,6c-.31,2.77,9.36,4.59,10,2.18.69-2.59,1.11-10-2.41-12.75s-9.3-3.71-9.3-3.71,4.53-3.06,3.05-3.71c-3.33-1.46-7.08,3.51-7.08,3.51s3.44-3.77,1.07-4.54C375.22,207.14,373.68,213.68,373.68,213.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,257.61l2.25,4.3s8.94-2.13,11.93-7l-4.25-3.13A15.23,15.23,0,0,1,374.6,257.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,257.31l-5.44,2.56s-.9-4,.51-6.91l4.93-2.11A8.89,8.89,0,0,0,371.68,257.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,257.61l2.25,4.3s8.94-2.13,11.93-7l-4.25-3.13A15.23,15.23,0,0,1,374.6,257.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.68,257.31l-5.44,2.56s-.9-4,.51-6.91l4.93-2.11A8.89,8.89,0,0,0,371.68,257.31Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.54,197.12v16.12a11.09,11.09,0,0,1-2.78.35,10.86,10.86,0,0,1-9.3-16.47Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.73,
    cy: 200.23,
    r: 10.86,
    transform: "translate(-20.11 351.91) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.19,200.23l3.6,2-1.23,2.14-3.66-2.14,0,4.07h-2.4l0-4-3.62,2.11-1.27-2.14,3.63-2-3.63-2,1.27-2.17,3.62,2.14,0-4h2.4l0,4.07,3.66-2.17,1.23,2.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.64,
    y: 253.85,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.64,
    y: 253.85,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.46,
    y: 258.67,
    width: 86.3,
    height: 86.3,
    transform: "translate(556.42 47.21) rotate(90)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.9,345H277.57c-.08-.79-.19-1.7-.29-2.71a1.6,1.6,0,0,0,0-.23c0-.23-.05-.44-.08-.67s0-.24,0-.36c-.09-.81-.19-1.68-.29-2.57,0-.29,0-.59-.09-.9-.05-.49-.1-1-.16-1.48-1.08-10.41-1.92-23.63,2.21-23.33,6.42.46,8.65,30.9,9.09,32.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.85,345h-7.26c-.09-.8-.2-1.7-.31-2.71a1.6,1.6,0,0,0,0-.23c0-.23-.05-.44-.08-.67s0-.24,0-.36c-.11-1.09-.25-2.26-.38-3.47-.05-.49-.1-1-.16-1.48,2.16-6.2,4.34-11.11,4.34-11.11A91.55,91.55,0,0,1,284.85,345Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5,345H242.71c0-1.32-.07-2.63-.13-3.93s-.14-2.59-.22-3.85c0-.36-.05-.72-.08-1.08-.1-1.14-.19-2.26-.32-3.35,0-.26-.06-.52-.08-.77-.14-1.14-.29-2.26-.47-3.31,0-.26-.07-.51-.12-.76s-.09-.5-.14-.75l-.14-.73c-.21-1.06-.45-2.06-.71-2.95-.09-.3-.19-.58-.27-.86-.33-1-.69-2.08-1.05-3.16a2.76,2.76,0,0,1,1.86-3.55,96,96,0,0,1,10.4-2.34,100.37,100.37,0,0,1,14.27-1.5c6.18-.05,13.29.64,13.29.64l0,0,0,0,0,0,0,0a.42.42,0,0,1,.1.12l.13.19a5.6,5.6,0,0,1,.29.71.6.6,0,0,1,.06.19l.06.19a1.29,1.29,0,0,0,.07.21c0,.16.08.31.12.5l.09.36c0,.13.06.26.08.41s.09.49.13.76c.14.83.26,1.83.39,3.06,0,.37.07.79.12,1.26s.1,1,.16,1.56A112.71,112.71,0,0,1,280.5,345Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5,345H242.72c-.06-2.63-.18-5.26-.36-7.78,0-.36-.05-.72-.08-1.08-.1-1.14-.19-2.26-.32-3.35,0-.26-.06-.52-.08-.77-.14-1.14-.29-2.26-.47-3.31,0-.26-.07-.51-.12-.76s-.09-.5-.14-.75l-.14-.73c-.21-1.06-.45-2.06-.71-2.95-.09-.3-.19-.58-.27-.86-.33-1-.69-2.08-1.05-3.16a2.76,2.76,0,0,1,1.86-3.55,96,96,0,0,1,10.4-2.34,100.37,100.37,0,0,1,14.27-1.5c6.18-.05,13.29.64,13.29.64l0,0,0,0,0,0,0,0a2.53,2.53,0,0,1,.52,1,.6.6,0,0,1,.06.19,11.35,11.35,0,0,1,.34,1.26c0,.13.06.26.08.41.18.94.37,2.18.53,3.82.06.74.16,1.68.27,2.82A112.71,112.71,0,0,1,280.5,345Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.59,345h-6.87c-.06-2.63-.18-5.26-.36-7.78,0-.36-.05-.72-.08-1.08-.1-1.14-.19-2.26-.32-3.35,0-.26-.06-.52-.08-.77A99.67,99.67,0,0,1,249.59,345Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,310.42s-8.46-.68-10.56,3.68,1.95,10.83,1.95,10.83l6.11-4.57L269,324.93l3.23-4.38,2.46,1.33S274.8,308.49,258.9,310.42Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.9,310.42s-8.46-.68-10.56,3.68,1.95,10.83,1.95,10.83l6.11-4.57L269,324.93l3.23-4.38,2.46,1.33S274.8,308.49,258.9,310.42Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.69,314.73s3.19,4.56,15.21,8.62c0,0,5.36-6.81-2.78-9.92,0,0-1.7-.53-2.06-3.22a13,13,0,0,1,.72-5.62q.14-.43.3-.9l-9.9-6.19S257.66,310,252.69,314.73Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.4,301.09s.53,7.08,6.66,9.12a13,13,0,0,1,.72-5.62C260.17,302.69,256.4,301.09,256.4,301.09Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.68 311.27 228.84 322.8 222.75 323.04 224.8 310.42 229.68 311.27",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.1,280.36a10.1,10.1,0,0,0-7.62-10.95,12.94,12.94,0,0,0-6.53-.17,16.27,16.27,0,0,0-12.6,15.51c-.27,8.1,1.63,18.46,13.31,17.52C274.64,300.75,269.1,280.36,269.1,280.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,277.4c8.18-.77,11.22,3.36,12.6,11.73,1.74,10.45.1,18.15-10.33,16.86C247.12,304.24,245.44,278.67,259,277.4Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.29,289.16a17.4,17.4,0,0,0,2.69,3.17,2.24,2.24,0,0,1-2.06,1.13Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.22,289c.08.68-.22,1.26-.66,1.31s-.88-.45-1-1.12.22-1.25.67-1.3S261.14,288.29,261.22,289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.09,287.9l1.39-.74S260.9,288.47,260.09,287.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.53,287.85c.08.67-.22,1.25-.66,1.31s-.87-.45-.95-1.12.22-1.26.66-1.31S269.46,287.18,269.53,287.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.4,286.78l1.39-.74S269.21,287.35,268.4,286.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.18,285.24a.32.32,0,0,1-.19-.05.36.36,0,0,1-.1-.49,4.6,4.6,0,0,1,3.73-1.72.35.35,0,0,1,.34.36.35.35,0,0,1-.36.34,3.94,3.94,0,0,0-3.13,1.41A.35.35,0,0,1,257.18,285.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.84,283.14a.29.29,0,0,1-.16,0,3.52,3.52,0,0,0-3-.36.34.34,0,0,1-.46-.17.34.34,0,0,1,.16-.46,4.17,4.17,0,0,1,3.64.38.35.35,0,0,1,.14.47A.36.36,0,0,1,269.84,283.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.37,292s3.19-7.08,2.13-12.21c0,0,15.58-8.13,17.91,8.24,0,0,.22-14.75-13.86-13.76s-12.1,21.54-4.27,27C253.28,301.27,249.4,296.43,251.37,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.87,293.61a3.62,3.62,0,0,0-4.17-2.92c-2.51.52-3.23,5.83,3.19,6.49C252.81,297.27,253.24,296.34,252.87,293.61Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.18,296.61a20.79,20.79,0,0,0-.9,2.8l-.51,0c-2.34-.2-3.36-1.07-3.78-2a3,3,0,0,1-.25-1.41,3,3,0,0,1,.14-.81,11.11,11.11,0,0,0,4.5,1.34C267.87,296.6,268.18,296.61,268.18,296.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.38,296.53l-.28.82c-2.2-.19-3.73-.63-4.36-1.35a3,3,0,0,1,.14-.81A11.11,11.11,0,0,0,267.38,296.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.77,299.37c-2.34-.2-3.36-1.07-3.78-2a7.29,7.29,0,0,1,2.55.73A2.9,2.9,0,0,1,266.77,299.37Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,285.74s3.93-6.26-2.73-8.73-13.15,6.11-9.15,12.05a9.2,9.2,0,0,0,10.39,3.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,313.28l-2.79-8.93,8.09-1.15s2.83,6-.91,9.92Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.6 297.81 229.84 298.39 230.46 303.19 222.37 304.35 223.6 297.81",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.83,315.91c-4.49-.19-12.07,19.38-12.07,19.38l1-18.24-7,.53s-6,29.2-3.75,32.1c2.79,3.63,10,5.13,23.33-12.82,0,0,2.95-7.45,2.51-13.36S240.83,315.91,240.83,315.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.16 320.31 221.99 315.9 230.12 315.55 229.93 319.3 221.16 320.31",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.16 320.31 221.99 315.9 230.12 315.55 229.93 319.3 221.16 320.31",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.52,358.41h0a1.33,1.33,0,0,1-1.32-1.33V356H235v1.08a1.33,1.33,0,0,1-1.33,1.33h0a4,4,0,0,0-4,3.48,3.85,3.85,0,0,0,3.84,4.23h.16a1.32,1.32,0,0,1,1.33,1.33v1.08H274.2v-1.08a1.32,1.32,0,0,1,1.32-1.33h.17a3.85,3.85,0,0,0,3.84-4.23A4,4,0,0,0,275.52,358.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,361.22a1.4,1.4,0,1,1-2,.11A1.4,1.4,0,0,1,276.84,361.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.67,
    y: 361.2,
    width: 0.48,
    height: 2.13,
    transform: "translate(-178.04 326.29) rotate(-48.17)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.72,363.6a1.4,1.4,0,1,1,.93-1.74A1.4,1.4,0,0,1,233.72,363.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.07,
    y: 361.2,
    width: 0.48,
    height: 2.13,
    transform: "translate(512.21 33.8) rotate(73.12)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.92,366.57a.85.85,0,0,1-.22,0,.67.67,0,0,1-.41-.38c-.21-.46.06-1.09.58-2.26.28-.62.86-1.91.71-2.2a4.39,4.39,0,0,0-1.94.08h0c-.17.48-.54,1-1,1.1a.73.73,0,0,1-.71-.33.77.77,0,0,1,0-.9,2.12,2.12,0,0,1,1-.64,1.36,1.36,0,0,0-.33-1.08c-.41-.44-2,0-3.15.85-.73.53-1,1.06-.94,1.26.58,1,2.22.62,2.23.62l.23.94c-.1,0-2.36.54-3.29-1.09-.42-.72,0-1.66,1.2-2.51s3.47-1.76,4.43-.72a2.3,2.3,0,0,1,.6,1.48,5.13,5.13,0,0,1,2,0,.94.94,0,0,1,.64.5,1.85,1.85,0,0,1,0,1.31l.3-.65c1.52-3.3,2-4.13,2.66-4.05,1.05.12,1.05,2.08,1,2.7a6.16,6.16,0,0,1,1.05-.19,2.41,2.41,0,0,1,2.06.54,1.56,1.56,0,0,1,.35.54c1.11-.59,2.83-1.37,3.63-1.05a.88.88,0,0,1,.55.55,1,1,0,0,1-.15.8,10.88,10.88,0,0,0,1.86-.29,2.11,2.11,0,0,1,.26-.61c.3-.48.86-.94,1.38-.82a.79.79,0,0,1,.59.78,1.06,1.06,0,0,1-.41.9,2.77,2.77,0,0,1-.42.27,54.13,54.13,0,0,0,8.56-.79l.15,1c-4.12.62-9.18,1.2-9.87.35l-.07-.09a8.39,8.39,0,0,1-2.73.26.64.64,0,0,1-.46-.39.9.9,0,0,1,.22-.85l.09-.14a9,9,0,0,0-3.3,1.32l-.83.48.11-.95h0a.75.75,0,0,0-.2-.56,1.55,1.55,0,0,0-1.27-.25,4.5,4.5,0,0,0-1.28.29c-.17.73-.52,1.1-.95,1.11a.71.71,0,0,1-.78-.64c0-.38.29-.79.87-1.13a5.4,5.4,0,0,0-.13-2,29.27,29.27,0,0,0-1.69,3.35C247.2,365.4,246.6,366.57,245.92,366.57Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.64,
    y: 121.46,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.64,
    y: 121.46,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.45,
    y: 126.28,
    width: 86.3,
    height: 86.3,
    transform: "translate(411.03 -72.17) rotate(90)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.54,192.08l4-5.8,3.87,6.83s-3.93,5-6.4,2.83Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.01 183.46 305.34 190.46 301.46 193.11 297.59 186.28 304.01 183.46",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.45 199.48 294.61 190.57 298.78 194.17 292.41 202.42 287.45 199.48",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.52,181.89c2.72,1.34,14.94,23.42,16,23.42,1.44,0,13.18-11.13,13.18-11.13l4.94,6.12S281.75,218,276.29,216.63c-5-1.27-18.94-19.44-18.94-19.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,200.3S281.75,218,276.29,216.63c-2.11-.54-5.87-4.16-9.49-8.14-4.85-5.33-9.45-11.3-9.45-11.3l2.8-8.3,2.37-7c2.71,1.34,14.94,23.41,16,23.41,1.44,0,13.17-11.12,13.17-11.12Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.8,208.49c-4.85-5.33-9.45-11.3-9.45-11.3l2.8-8.3a5.3,5.3,0,0,1,.87.85C264.47,193.89,266.89,201.14,266.8,208.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,211.39c0,.4-.05.79-.07,1.19H220.45c1.36-11.52,1.93-23.72,1.93-23.72l.79,0c.89,0,2.5-.11,4.56-.16,1.74,0,3.82-.08,6.08-.09,7.53,0,17,.33,22.74,1.89a11.85,11.85,0,0,1,3.7,1.55,2.76,2.76,0,0,1,1.35,2C261.76,196.32,261.46,203.13,261,211.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,211.39c-.07.39-.14.78-.21,1.19h-40c.66-4.17,1.27-8.71,1.73-13.46.32-3.34.56-6.78.69-10.3.15-4.25.14-8.58-.1-12.92,0,0,3.11-.2,7-.13.82,0,1.67,0,2.53.08s1.51.08,2.28.13l.72.06a133.63,133.63,0,0,1,15.65,2.17c.63.14,1.25.3,1.86.46a72.53,72.53,0,0,1,8.44,2.89v0C261.72,182.15,264,192.73,261,211.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,211.39c-.07.39-.14.78-.21,1.19h-40c.66-4.17,1.27-8.71,1.73-13.46.32-3.34.56-6.78.69-10.3.15-4.25.14-8.58-.1-12.92,0,0,3.11-.2,7-.13.82,0,1.67,0,2.53.08s1.51.08,2.28.13l.72.06a133.63,133.63,0,0,1,15.65,2.17c.63.14,1.25.3,1.86.46a72.53,72.53,0,0,1,8.44,2.89v0C261.72,182.15,264,192.73,261,211.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.77,159c-.26,5.15-1.57,14.41-5.85,16.86,0,0,8.45,6.66,11,6.64,1.79,0,4.37-2.94,4.37-2.94-5.18-2.64-4-6.68-2.09-10.27Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,163.21l4.38,6.08A17.13,17.13,0,0,0,249,171.9c-2-.81-4.35-3.81-4-6.06A7.62,7.62,0,0,1,245.8,163.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.55,148.64c.84,2.67.38,8.17-3.35,6.38S260.11,144.05,261.55,148.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.29,152.25c-.41,6.87-1,10.88,2,14.76,4.56,5.85,13.38,3.67,15.84-3,2.22-6,2.52-16.19-3.85-19.66A9.5,9.5,0,0,0,242.29,152.25Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,148.52v-7.68s-8.17-.6-7.81,3.58c-4.52,2.24-2.38,9.28,3.7,12.73,3.33-2.66,2.94-9.08,2.94-9.08C246.3,148.23,246.7,148.37,247.11,148.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,157.62a6.47,6.47,0,0,0,2.75,4.15c1.91,1.26,3.58-.29,3.65-2.46.06-2-.86-5-3.06-5.35A3,3,0,0,0,239,157.62Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.44,155.32c-.07.56.17,1,.53,1.08s.72-.38.79-.93-.18-1-.54-1.08S252.51,154.76,252.44,155.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.73,156c-.06.56.18,1,.54,1.08s.71-.37.78-.93-.17-1-.54-1.08S258.8,155.47,258.73,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.7,156.08a19.05,19.05,0,0,0,2.15,4.88,3.33,3.33,0,0,1-2.71.15Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.74,153.07a.32.32,0,0,0,.32-.09,2.62,2.62,0,0,1,2.23-.85.34.34,0,0,0,.39-.27.34.34,0,0,0-.26-.38,3.3,3.3,0,0,0-2.83,1.05.32.32,0,0,0,0,.46A.23.23,0,0,0,250.74,153.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.71,154.17a.41.41,0,0,0,.19,0,.33.33,0,0,0,.2-.42,3.21,3.21,0,0,0-2.12-2.1.33.33,0,0,0-.17.64,2.5,2.5,0,0,1,1.67,1.68A.37.37,0,0,0,261.71,154.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.3,144.42s-4.38-4,9.91-4.23,17,7.66,10.54,9.8l-.36-1.29a8.88,8.88,0,0,1-7.3.69l1-.69S243.4,150.12,239.3,144.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.9,162.9a22,22,0,0,0-1.72,2.64l-.52-.18c-2.36-.88-3.17-2.06-3.35-3.11a3.15,3.15,0,0,1,.14-1.53,3,3,0,0,1,.37-.8,11.85,11.85,0,0,0,4.28,2.67C255.59,162.8,255.9,162.9,255.9,162.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.1,162.59l-.53.77c-2.22-.83-3.67-1.71-4.12-2.64a3,3,0,0,1,.37-.8A11.85,11.85,0,0,0,255.1,162.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.66,165.36c-2.36-.88-3.17-2.06-3.35-3.11a8.14,8.14,0,0,1,2.43,1.49A3.07,3.07,0,0,1,253.66,165.36Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,182.51s-2,1.87-4.41,3.68c-2.82-1.89-9.38-6.8-8.58-10.52.55-1,3.49-1.39,3.49-1.39S241,178.7,247.91,182.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,182.51a19.88,19.88,0,0,1,3.39,4.61c2.38-1.17,2.1-8.3,1.38-9.17a7.87,7.87,0,0,0-3.69-1.46A6.53,6.53,0,0,1,247.91,182.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.91,182.51s-2,1.87-4.41,3.68c-2.82-1.89-9.38-6.8-8.58-10.52.55-1,3.49-1.39,3.49-1.39S241,178.7,247.91,182.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.91,182.51a19.88,19.88,0,0,1,3.39,4.61c2.38-1.17,2.1-8.3,1.38-9.17a7.87,7.87,0,0,0-3.69-1.46A6.53,6.53,0,0,1,247.91,182.51Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.91,175.68v.3c0,1.23-.26,6-1.1,12.59-.54,4.19-1.33,9.12-2.5,14.31v0c-.7,3.16-1.55,6.41-2.56,9.66h-9.49c.05-.68.11-1.39.17-2.11s.13-1.68.2-2.54c.19-2.63.38-5.38.54-8.1h0v-.08c0-.6.08-1.22.11-1.83.07-1.37.15-2.71.22-4,0-.66.07-1.29.1-1.93,0-.85.08-1.68.12-2.47,0-.27,0-.54,0-.81,0-.65.06-1.28.08-1.9s.06-1.27.09-1.88l0-.7c0-.46,0-.91.06-1.34s0-.68,0-1c0-.49,0-1,.05-1.4,0-.68.06-1.31.08-1.87,0-.15,0-.29,0-.44.06-1.56.09-2.45.09-2.45a44.12,44.12,0,0,1,9.18-.36C231.83,175.39,233.32,175.49,234.91,175.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.91,175.68v.3c0,1.23-.26,6-1.1,12.59-.54,4.19-1.33,9.12-2.5,14.31v0c-.7,3.16-1.55,6.41-2.56,9.66h-9.49c.05-.68.11-1.39.17-2.11s.13-1.68.2-2.54c.19-2.63.38-5.38.54-8.1h0v-.08c0-.6.08-1.22.11-1.83.07-1.37.15-2.71.22-4,0-.66.07-1.29.1-1.93,0-.85.08-1.68.12-2.47,0-.27,0-.54,0-.81,0-.65.06-1.28.08-1.9s.06-1.27.09-1.88l0-.7c0-.46,0-.91.06-1.34s0-.68,0-1c0-.49,0-1,.05-1.4,0-.68,0-1.31.08-1.87,0-.15,0-.29,0-.44.06-1.56.09-2.45.09-2.45a44.12,44.12,0,0,1,9.18-.36C231.83,175.39,233.32,175.49,234.91,175.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.92,175.67a157.84,157.84,0,0,1-3.6,27.21v0l-4.87-19.42,5.15-.49-5.15-3,4.05-4.68C231.84,175.38,233.32,175.49,234.92,175.67Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,212.58h-3.92c0-.9,0-1.8-.06-2.72,0-1.31-.09-2.57-.14-3.77a151,151,0,0,0-1.37-15.63c-1.4-9.45-3.24-11.61-3.4-11.78l3.33,1.14,5.1,1.76.94.32C263.16,189,262.79,200.58,262,212.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,212.58h-3.92c0-.9,0-1.8-.06-2.72,0-1.31-.09-2.57-.14-3.77a151,151,0,0,0-1.37-15.63c-1.4-9.45-3.24-11.61-3.4-11.78l3.33,1.14,5.1,1.76.94.32C263.16,189,262.79,200.58,262,212.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.73,186.73l3.81,2.39s-1,11.23-2.62,17c-1-23-4.54-27.15-4.77-27.4l3.33,1.13a22.48,22.48,0,0,1,4.54,5.9Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.38,192.27a19.82,19.82,0,0,1-2.21,7.54c.16-2.67.3-5.33.44-7.86A4.16,4.16,0,0,1,222.38,192.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.09,183.36a28.12,28.12,0,0,1-1.71,8.92s-13.91,12.44-13.53,15.47a30.08,30.08,0,0,0,1.59,4.83H200.12a15.46,15.46,0,0,1-.92-5.61c.77-7.14,18-30.85,22.1-31.29C221.3,175.68,224.28,178.1,224.09,183.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.09,183.36a28.12,28.12,0,0,1-1.71,8.92s-13.91,12.44-13.53,15.47a30.08,30.08,0,0,0,1.59,4.83H200.12a15.46,15.46,0,0,1-.92-5.61c.77-7.14,18-30.85,22.1-31.29C221.3,175.68,224.28,178.1,224.09,183.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.52,226h0a1.32,1.32,0,0,1-1.33-1.33v-1.08H222v1.08a1.32,1.32,0,0,1-1.32,1.33h0a4,4,0,0,0-4,3.48,3.86,3.86,0,0,0,3.84,4.23h.17a1.33,1.33,0,0,1,1.32,1.33v1.08h39.18v-1.08a1.33,1.33,0,0,1,1.33-1.33h.16a3.85,3.85,0,0,0,3.84-4.23A4,4,0,0,0,262.52,226Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.83,228.84a1.38,1.38,0,0,1,.11,2,1.4,1.4,0,0,1-2.08-1.86A1.38,1.38,0,0,1,263.83,228.84Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.66,
    y: 228.81,
    width: 0.48,
    height: 2.13,
    transform: "translate(-83.71 272.54) rotate(-48.18)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.71,231.21a1.4,1.4,0,1,1-.81-2.67,1.4,1.4,0,0,1,.81,2.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.06,
    y: 228.81,
    width: 0.48,
    height: 2.13,
    transform: "translate(376.29 -47.69) rotate(73.12)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.37,233.73a.72.72,0,0,1-.46-.16c-.25-.18-.76-.57.62-3.94l.1-.23a25.42,25.42,0,0,1-3.23,1.38l-.32-.9a24.22,24.22,0,0,0,4.23-2c1.08-2.18,1.59-2.12,1.78-2.09a.65.65,0,0,1,.53.64c.09.72-.6,1.45-1.56,2.1a18.71,18.71,0,0,0-1.49,4.12,15.8,15.8,0,0,0,2-1.76,13,13,0,0,1,3-2.46,1.54,1.54,0,0,1,1.44,0,1.62,1.62,0,0,1,.43,1.51c.52,0,1.87.1,5.44.11a2,2,0,0,1-.05-.26,3.07,3.07,0,0,1,1.2-2.9,1.5,1.5,0,0,1,1.72,0,1.61,1.61,0,0,1,.73,1.87,3.75,3.75,0,0,1-1.82,2l.28.09a2.9,2.9,0,0,0,2.41-.18,2,2,0,0,0,.8-1.31.94.94,0,0,1,1-.8,2,2,0,0,1,1.79,1.1,66.88,66.88,0,0,1,8.36-.33v1a64.72,64.72,0,0,0-8.34.33,1.09,1.09,0,0,1-.59.82.82.82,0,0,1-1-.41.64.64,0,0,1-.06-.69c.07-.15.16-.32.66-.48a.88.88,0,0,0-.26-.18,1,1,0,0,0-.66-.14,2.69,2.69,0,0,1-1.17,1.93,3.81,3.81,0,0,1-3.19.31,2.61,2.61,0,0,1-1.3-.74c-6.55,0-6.64-.13-6.83-.39a1,1,0,0,1-.09-.69c0-.15,0-.61,0-.72a1.58,1.58,0,0,0-.48.14,13.07,13.07,0,0,0-2.68,2.26C230,232.84,229.06,233.73,228.37,233.73Zm14.47-6.16a.61.61,0,0,0-.34.12,2.12,2.12,0,0,0-.77,1.94,1.34,1.34,0,0,0,.11.37,2.89,2.89,0,0,0,1.66-1.53.63.63,0,0,0-.33-.79A.62.62,0,0,0,242.84,227.57Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.22,
    y: 253.85,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.22,
    y: 253.85,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.04,
    y: 258.67,
    width: 86.3,
    height: 86.3,
    transform: "translate(440 163.63) rotate(90)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--group--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.84,321.25a85.19,85.19,0,0,0-8.73-9.75,8.8,8.8,0,0,0-12.64,12.22l.12.13c2.55,2.87,5.38,5.79,8,8.58,1.29,1.41,2.6,2.78,3.69,4.09.54.64,1.07,1.26,1.39,1.68a2.09,2.09,0,0,1,.14.17.86.86,0,0,1,0,.16,16.27,16.27,0,0,1-.43,2.32c-.26,1.32-.66,2.7-1.08,4.12h12V324.68C180.53,323.48,179.7,322.34,178.84,321.25Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,303c8.14.59,18.77,11.42,18.77,11.42.72,3.24-3.54,14.39-9.14,18.77,0,0-5.85.61-10-6C150.94,319.91,147.26,302.36,155.9,303Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.28,327.52a21.61,21.61,0,0,1-4.75,5.64,9.58,9.58,0,0,1-4.8-1.1,13.11,13.11,0,0,1-5.24-4.93c-4.55-7.22-8.23-24.77.4-24.16,8.15.59,18.78,11.43,18.78,11.43C175.17,316.62,173.31,322.58,170.28,327.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.28,327.52a21.61,21.61,0,0,1-4.75,5.64,9.58,9.58,0,0,1-4.8-1.1c-2.21-4.8-3.67-10.61-3.06-15.73C157.67,316.33,166.44,319,170.28,327.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.25,345H108.5c.27-2.38.53-4.86.77-7.39.17-1.81.33-3.65.45-5.52l.09-1.29c0-.08,0-.15,0-.23.06-.88.1-1.75.14-2.64.06-1.1.11-2.19.14-3.3a134.25,134.25,0,0,0-.18-13.75A11.32,11.32,0,0,1,121,298.7a151.51,151.51,0,0,1,33.31,3.81c3.82.9,7.59,3.6,8.1,7.5C164.17,323.63,169.38,333.43,171.25,345Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,319.77s-2.86,13.18-12.75,17.81c.39-4.19.7-8.56.84-13C116.39,321.82,122,319.77,122,319.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.83,303.74a7,7,0,0,0-2.94-3.61,6.61,6.61,0,0,1,.46-4.39l-15.7-7.35c.62,5.59,1.1,10-1.26,12.37,3,2.38,8.41,6.68,14.86,7.34S149.59,306.15,148.83,303.74Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.15,296.23,134,293.91c3.31,4.61,8.93,6.91,11.8,5.59A6.67,6.67,0,0,1,146.15,296.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,308.13l-2.37-2.56-3.81,1.33S140.47,309.33,144.64,308.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,308.13l-2.37-2.56-3.81,1.33S140.47,309.33,144.64,308.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,297.26s4.44,7.09,11.28,8.31a9.16,9.16,0,0,0-5.51,5.78s-8.24-3.73-8.67-13.07A3.35,3.35,0,0,1,131,297.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,308.13l3.36-2.3,3.69,1.63S148.37,310.36,144.64,308.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64,308.13l3.36-2.3,3.69,1.63S148.37,310.36,144.64,308.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,300.13s2.28,3.44,2.11,5.7c3.1,1.32,4,6.24,4,6.24s1.46-6.66-3.11-11A5.49,5.49,0,0,0,145.89,300.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,297.26s4.44,7.09,11.28,8.31a9.16,9.16,0,0,0-5.51,5.78s-8.24-3.73-8.67-13.07A3.35,3.35,0,0,1,131,297.26Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,300.13s2.28,3.44,2.11,5.7c3.1,1.32,4,6.24,4,6.24s1.46-6.66-3.11-11A5.49,5.49,0,0,0,145.89,300.13Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.35,269.06s3.5.79,4.66,3,2.69,10.47.35,11.34-9-1.52-9.29-4.39S144.35,269.06,144.35,269.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54,279.69c1,7.3,1.9,12.24,6.7,15.17,9.52,5.82,14.67,1.63,16-5.76,1.2-6.65-.7-17.48-8.62-20.05S127.5,272.39,128.54,279.69Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,280.33a3.64,3.64,0,0,0-2.79,0A7.27,7.27,0,0,0,140.12,280.33Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.08,281a3,3,0,0,0-2.44.65A6,6,0,0,0,140.08,281Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,273.68a33.19,33.19,0,0,0-7-.21C144.16,273.73,147.25,273.68,147.25,273.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.23,274.45s-5.33-.12-7.92.7A63.32,63.32,0,0,0,148.23,274.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,280.54c0,.65.4,1.15.82,1.12s.74-.57.7-1.21-.4-1.15-.82-1.12S142.36,279.9,142.4,280.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.05,280.35c0,.64.41,1.14.83,1.11s.73-.57.7-1.21-.41-1.14-.83-1.12S149,279.7,149.05,280.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.87,278.9a.64.64,0,0,1-.18-.06.38.38,0,0,1-.1-.53,3.81,3.81,0,0,1,3-1.75.37.37,0,0,1,.37.38.37.37,0,0,1-.38.37h0a3,3,0,0,0-2.35,1.42A.38.38,0,0,1,138.87,278.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52,278.45a.38.38,0,0,1-.32-.15,3,3,0,0,0-2.39-1.31.37.37,0,0,1-.39-.36.38.38,0,0,1,.36-.4,3.74,3.74,0,0,1,3,1.62.38.38,0,0,1-.09.53A.33.33,0,0,1,151.52,278.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.91,288.73s-2.7-.57-10.25-.43c.93,2.25,2.61,4.07,6.48,4A3.51,3.51,0,0,0,149.91,288.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.31,290.52a7.14,7.14,0,0,1,4.24,1,4.13,4.13,0,0,1-2.41.73,6.9,6.9,0,0,1-4.22-1A4.11,4.11,0,0,1,144.31,290.52Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.57,288.67a1.57,1.57,0,0,1-1.16,1.15,40.43,40.43,0,0,1-6.7-.44,2.13,2.13,0,0,1-1.72-1.09A61.91,61.91,0,0,1,149.57,288.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,266.06c-2.34-1-12.7.63-15.65,5.26a13.77,13.77,0,0,0-.1,14.75,49,49,0,0,0,6.58,1.73c3.27.58,3.59-8.69,1.68-11.05,0,0-.16-.13-.45-.32-1.14-.86-3-2.52-2.92-3.33s3.72-3.89,5.9-3.68,4.72,1.25,6.11,1.27a9.11,9.11,0,0,0,2.22-.2S144.44,267.08,142.1,266.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,287.76a7.47,7.47,0,0,0,4.87,3c2.61.4,3.62-2,2.66-4.31-.87-2.07-3.27-4.78-5.77-4.13A3.4,3.4,0,0,0,126,287.76Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.64,284s.1,3.45.67,4.28,2.76-1.81,3.68-2.49,6.36,1,6.36,1a3.35,3.35,0,0,1-.09.71,45.92,45.92,0,0,1-6.16-.06c-.64-.21-2.88,2.58-.66,5.07s4.39,2.77,5.32,2.49.52-1.84.52-1.84l1.67-.05s-.14,1.45.63,1.9,2.58-2.95,3-4.9-.51-2.72-3.11-2.37l-.08-1.08s3.4-1,3.73-.68c.83.69,1,4.18.41,6.24s-2.39,6.1-6.94,6S136.29,296.5,134,294s0-6.5,0-6.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,281l.25,5.41a6.16,6.16,0,0,0,1.91,0,.71.71,0,0,0,.32-1.21A12.62,12.62,0,0,1,146.87,281Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.93,318.81l-3.8,5.78c-1.27,1.94-2.5,3.9-3.69,5.81s-2.26,3.84-3.14,5.58c-.43.86-.77,1.69-1,2.26-.12.28-.19.5-.23.49s0-.27-.31-1.19a2.5,2.5,0,0,0-.15-.38l-.1-.23-.15-.31A6.54,6.54,0,0,0,108,336a5.87,5.87,0,0,0-.62-.79,3.85,3.85,0,0,0-.51-.49,2.56,2.56,0,0,0-.93-.58c-.21-.06,0,.1.32.23a17,17,0,0,0,2.62.87c2.06.51,4.35,1,6.67,1.46,4.64.91,9.5,1.71,14.28,2.74l.1,0a4.44,4.44,0,0,1-.06,8.69A100.07,100.07,0,0,1,114.63,350a72.39,72.39,0,0,1-8-.11,35.69,35.69,0,0,1-4.61-.66,15.54,15.54,0,0,1-3.13-1.06,10.85,10.85,0,0,1-2.48-1.59,10.63,10.63,0,0,1-.83-.82,10.13,10.13,0,0,1-.9-1.16c-.15-.23-.31-.52-.45-.78l-.2-.42-.15-.33c-.11-.27-.21-.55-.3-.82a13.41,13.41,0,0,1-.59-4.86,20.55,20.55,0,0,1,.43-3.14,32,32,0,0,1,1.4-4.71,62.24,62.24,0,0,1,3.45-7.65c1.23-2.38,2.57-4.63,3.94-6.84.7-1.1,1.4-2.19,2.14-3.26s1.46-2.08,2.32-3.22A8.8,8.8,0,0,1,121,318.63Z",
    style: {
      fill: "#e9b376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.81,299.13c-9.36,2.76-20.63,17.45-20.63,17.45.26,5.22,10.56,14.23,17.17,14.58,0,0,6.54-6.06,9.1-13.31C126.08,310.4,121.94,300.16,117.81,299.13Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.81,299.13c-9.36,2.76-20.63,17.45-20.63,17.45.26,5.22,10.56,14.23,17.17,14.58,0,0,6.54-6.06,9.1-13.31C126.08,310.4,121.94,300.16,117.81,299.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.64,339.53l-2,4.66c-.27,5.33,6.65,4.49,6.65,4.49l3.48.94a2.68,2.68,0,0,0,3.05-1.68l1.45-3.25a2.8,2.8,0,0,0-1.12-3.75l-2.86-1.3a5.46,5.46,0,0,0-2.67-.49Z",
    style: {
      fill: "#ebb376"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,358.41h0a1.34,1.34,0,0,1-1.33-1.33V356H119.15v1.08a1.33,1.33,0,0,1-1.32,1.33h0a4,4,0,0,0-4,3.48,3.86,3.86,0,0,0,3.84,4.23h.17a1.32,1.32,0,0,1,1.32,1.33v1.08h39.18v-1.08a1.33,1.33,0,0,1,1.33-1.33h.16a3.85,3.85,0,0,0,3.84-4.23A4,4,0,0,0,159.66,358.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,361.22a1.4,1.4,0,0,1-1.86,2.09,1.4,1.4,0,0,1,1.86-2.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.8,
    y: 361.2,
    width: 0.48,
    height: 2.13,
    transform: "translate(-216.64 239.94) rotate(-48.17)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,363.6a1.4,1.4,0,1,1,.93-1.74A1.39,1.39,0,0,1,117.85,363.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.21,
    y: 361.2,
    width: 0.48,
    height: 2.13,
    transform: "translate(429.99 144.68) rotate(73.12)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.87,365.44a.62.62,0,0,1-.4-.15c-.44-.36-.42-1.45-.25-2.25-.35.45-.71.73-1.15.62-.74-.19-.67-1-.63-1.41a2.68,2.68,0,0,0,0-.4h-.06c-.45.07-1.32,1-1.9,1.68-.87,1-1.33,1.49-1.86,1.46a.69.69,0,0,1-.51-.29,1.12,1.12,0,0,1-.14-.85,3.17,3.17,0,0,1-1.88-.33,3,3,0,0,0-.78-.28,2.35,2.35,0,0,1-.45.69.65.65,0,0,1-.76.15.81.81,0,0,1-.47-.68,1,1,0,0,1,.49-.9,1.81,1.81,0,0,1,.52-.21,3.44,3.44,0,0,0,.13-1.91.44.44,0,0,0-.46-.34c-1.22,0-2.83,2.8-3.56,4.56l-.89-.36c.22-.53,2.19-5.16,4.45-5.16a1.38,1.38,0,0,1,1.35.93,4.08,4.08,0,0,1,0,2.32,3.65,3.65,0,0,1,.89.33,2.14,2.14,0,0,0,1.78.11,8.78,8.78,0,0,1,.87-1.57c.12-.15.46-.57.88-.41a.63.63,0,0,1,.36.72,2.69,2.69,0,0,1-1.35,2,2.13,2.13,0,0,0-.09.27c.25-.24.56-.59.79-.85.83-.92,1.69-1.87,2.48-2a1,1,0,0,1,.88.21,1.41,1.41,0,0,1,.26,1.22c0,.06,0,.13,0,.21.18-.22.41-.59.57-.84.49-.77.92-1.44,1.51-1.48a.82.82,0,0,1,.69.33,2.16,2.16,0,0,1,.39,1.32,29.2,29.2,0,0,0,5.09-.08c.36-.09.53-.37.76-.78s.39-.69.81-.78a1,1,0,0,1,.84.24c.67.5.7,1,.58,1.34a1,1,0,0,1,.71,0,38.67,38.67,0,0,0,5.8,0l0,1c-.88,0-5.34.25-6.15,0-.13,0-.47.27-.6.39s-.5.47-.86.29a.69.69,0,0,1-.29-.74,2.3,2.3,0,0,1,.32-.9,1.09,1.09,0,0,0,.12-.26h0s0-.08-.25-.25l-.06,0c0,.07-.12.19-.17.28a2.16,2.16,0,0,1-1.37,1.24,27.52,27.52,0,0,1-5.42.11,4.4,4.4,0,0,1-1.17,2.46A.72.72,0,0,1,137.87,365.44Zm.45-2.69a3,3,0,0,0-.25,1.24,5,5,0,0,0,.41-1.22Zm-.07-1h.1l.24,0a1.32,1.32,0,0,0-.12-.55,3.52,3.52,0,0,0-.42.54Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.22,
    y: 121.46,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.22,
    y: 121.46,
    width: 95.93,
    height: 95.93,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.03,
    y: 126.28,
    width: 86.3,
    height: 86.3,
    transform: "translate(294.61 44.25) rotate(90)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.34,187.67c1.25,1.14,2.66,2.44,4,3.59s2.8,2.32,4.21,3.39a44.59,44.59,0,0,0,4.25,2.86,13.71,13.71,0,0,0,3.65,1.57l.13,0a3.27,3.27,0,0,0-.44,0,2.44,2.44,0,0,0-.74.27c-.36.23-.38.34-.31.3a4.27,4.27,0,0,0,.86-1.3,29.58,29.58,0,0,0,1.72-4.77c1-3.48,1.79-7.26,2.55-10.94l0-.09a2.54,2.54,0,0,1,5,.29,62.76,62.76,0,0,1,0,12.18,31.75,31.75,0,0,1-1.3,6.46,13.55,13.55,0,0,1-1.9,3.8,7.73,7.73,0,0,1-2.51,2.17,6.62,6.62,0,0,1-2.12.71,7.54,7.54,0,0,1-1.16.08l-.6,0a19.83,19.83,0,0,1-7.32-2.11,42.65,42.65,0,0,1-5.63-3.29,58.31,58.31,0,0,1-5-3.76c-1.58-1.35-3.07-2.63-4.6-4.2a5.1,5.1,0,0,1,7.06-7.35Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.06,182.79c8.19-1.48,11.38,3.21,21,11.37A17.4,17.4,0,0,1,143.33,207S123.29,193.92,130.06,182.79Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.44,193.93c3.47,6.38,10.92,11.71,12.56,12.83-.58-2.91-2.41-9.07-7.82-13A3.5,3.5,0,0,0,130.44,193.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,149.67s7.33,18.34,0,34.32-27.94,6.38-30,2.55,2.74-11.63,2.74-18.77-2.32-11.2-.44-16.9C107.64,138.72,131.33,149.67,131.33,149.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51,212.58H105.78c-.07-.74-.14-1.48-.2-2.2-.35-3.73-.78-7.19-1.23-10.29a157.7,157.7,0,0,0-3.19-16.54c17.77-8.58,34.48-.71,34.48-.71C139.88,189,140.73,201.53,140.51,212.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.51,212.58H105.78c-.07-.74-.14-1.48-.2-2.2-.35-3.73-.78-7.19-1.23-10.29a157.7,157.7,0,0,0-3.19-16.54c17.77-8.58,34.48-.71,34.48-.71C139.88,189,140.73,201.53,140.51,212.58Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.36,200.08c.44,3.1.87,6.56,1.22,10.3a25.42,25.42,0,0,0,.93-17.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,177.3c-10.22,0-11.5,8.41-11.5,8.41l4.78-2.06,14,9.4,3.45-9.49,4.33.81S126.89,177.31,118,177.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.87,192.48,111.69,181c3.21-3.29,1.57-12.31.24-17.24l10,8c-.67,3.82-.51,7.9,5.08,9.21C127,181,124.86,192.45,124.87,192.48Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,167.06l5.92,4.74a14.09,14.09,0,0,0-.27,2.72c-2.12-.31-5.18-2.61-5.56-4.8A7.23,7.23,0,0,1,116,167.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.33,152c-.2,8.09-.45,11.5,3.19,16.18,5.47,7,15.28,6,17.85-1.71,2.31-7,2.25-19-5.21-23.31A10.37,10.37,0,0,0,109.33,152Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.22,147.77c-5.48,4.62,2,12.88-6.76,10.62s-2.49-13.93,3.35-15.64S117.22,147.77,117.22,147.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.37,155.89c0,.68.27,1.28.69,1.34s.82-.45.86-1.13-.26-1.27-.69-1.33S121.42,155.21,121.37,155.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.42,157.12c0,.68.26,1.28.69,1.33s.81-.44.86-1.12-.27-1.27-.69-1.33S129.46,156.44,129.42,157.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,156l1.61-.25S130.79,156.92,130.08,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.1,157.92a19.7,19.7,0,0,0,2,4.65,2.7,2.7,0,0,1-2.37.13Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.83,164.69a5.92,5.92,0,0,0,1.1.25.18.18,0,0,0,.2-.17.22.22,0,0,0-.18-.23,5.62,5.62,0,0,1-4.08-2.68.19.19,0,0,0-.26-.09.18.18,0,0,0-.08.26A5.92,5.92,0,0,0,122.83,164.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,159.3a5.58,5.58,0,0,0,2.69,3.6c1.71.87,2.94-1,2.78-3.24-.15-2-1.21-4.82-3.07-4.74S106.45,157.28,107,159.3Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91,151.88a.36.36,0,0,0,.3-.06,2.92,2.92,0,0,1,2.72-.43.35.35,0,0,0,.49-.21.44.44,0,0,0-.23-.53,3.66,3.66,0,0,0-3.45.5.41.41,0,0,0-.07.56A.4.4,0,0,0,119.91,151.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,153.72a.34.34,0,0,0,.28,0,.39.39,0,0,0,.13-.54,4.17,4.17,0,0,0-3-2.17.36.36,0,0,0-.4.36.43.43,0,0,0,.37.44,3.31,3.31,0,0,1,2.34,1.74A.44.44,0,0,0,132,153.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122,154.78l1.6-.25S122.75,155.69,122,154.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.78,144.66s-4.58,9.93-12.5,9.45-3.71-11.4,7.41-13.38,17.64,8.08,17.63,10.41a3.91,3.91,0,0,1-2.35,3.32S129.75,146.58,121.78,144.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,196.37c-1.57,3.07-3.21,6.27-4.71,9.35-.74,1.55-1.47,3.1-2.06,4.56-.29.72-.53,1.44-.7,2-.08.25-.12.49-.14.41s0-.15-.13-.58a3.87,3.87,0,0,0-.42-.89,3.71,3.71,0,0,0-.48-.6,2,2,0,0,0-.31-.27c-.76-.53-.84-.37-.76-.37a3.19,3.19,0,0,0,.64.14,14.3,14.3,0,0,0,2.16.1c1.59,0,3.32-.14,5-.31,3.46-.33,7-.8,10.59-1.18h.06a2.55,2.55,0,0,1,1.33,4.86,74.74,74.74,0,0,1-10.56,3.84,48.08,48.08,0,0,1-5.7,1.28,24.31,24.31,0,0,1-3.27.3,12.23,12.23,0,0,1-2.06-.15,6.94,6.94,0,0,1-3.26-1.37,6.66,6.66,0,0,1-.56-.5,6.12,6.12,0,0,1-.69-.87,6.23,6.23,0,0,1-.68-1.52,7.49,7.49,0,0,1-.28-1.92,12.57,12.57,0,0,1,.19-2.29,25.34,25.34,0,0,1,.8-3.25,57.34,57.34,0,0,1,2-5.51,97.63,97.63,0,0,1,5-10.11,5.1,5.1,0,0,1,9,4.81Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.2,182.81c-5.49.84-8.5,5.12-13,16.14,5.19,8.93,12.91,10.15,12.91,10.15S110.74,195.57,103.2,182.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.06,195.88a.64.64,0,1,0,.64-.64A.64.64,0,0,0,125.06,195.88Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,205.31a.64.64,0,1,0,1.28,0,.64.64,0,1,0-1.28,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.52,182.19l-.58-7.06,7.34,2.79s.14,6.32-3.12,6.26Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.08 168.86 167.57 173.4 166.28 177.92 158.94 175.13 162.08 168.86",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.63,208.73l8.29-.67L120,213.57s-6,2-6.9-1.16Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.34 212.58 121.92 215.09 120.03 213.57 121.92 208.06 126.34 212.58",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.1,226h0a1.32,1.32,0,0,1-1.33-1.33v-1.08H105.59v1.08a1.32,1.32,0,0,1-1.32,1.33h0a4,4,0,0,0-4,3.48,3.85,3.85,0,0,0,3.84,4.23h.17a1.33,1.33,0,0,1,1.32,1.33v1.08h39.18v-1.08a1.33,1.33,0,0,1,1.33-1.33h.16a3.85,3.85,0,0,0,3.84-4.23A4,4,0,0,0,146.1,226Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.41,228.84a1.38,1.38,0,0,1,.11,2,1.4,1.4,0,0,1-2,.11,1.4,1.4,0,0,1,1.86-2.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.24,
    y: 228.81,
    width: 0.48,
    height: 2.13,
    transform: "translate(-122.5 185.73) rotate(-48.17)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.29,231.21a1.4,1.4,0,1,1,.93-1.74A1.4,1.4,0,0,1,104.29,231.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.64,
    y: 228.81,
    width: 0.48,
    height: 2.13,
    transform: "translate(293.68 63.71) rotate(73.12)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.61,233.76a1.21,1.21,0,0,1-.38-.06.82.82,0,0,1-.48-.47c-.25-.64.2-1.88.61-2.8a22.64,22.64,0,0,1-3.91-.06,5.47,5.47,0,0,1-.92-.2,7.54,7.54,0,0,1-4.63.34,18.7,18.7,0,0,1-2.17,1c-1.25.48-4.22,1.51-4.94.8-.36-.36-.34-1.08-.12-1.91h-4.06v-1H113a10.73,10.73,0,0,1,1.33-2.45c1.17-1.53,2.08-1.33,2.51-1.08a1.48,1.48,0,0,1,.72,1.75,4.37,4.37,0,0,1-3.6,2.74h-.28a2.87,2.87,0,0,0-.2,1.19,15.65,15.65,0,0,0,5.29-1.56l0,0a1.27,1.27,0,0,1-.51-1.65c.36-.66,1.46-1,2.78-.28a.85.85,0,0,1,.52.82,1.38,1.38,0,0,1-.55.88,7.28,7.28,0,0,0,2.34-.19,2.09,2.09,0,0,1-.68-1.7.8.8,0,0,1,.58-.76,2.41,2.41,0,0,1,2.26.87,1.14,1.14,0,0,1,0,1.42v0h0a23.73,23.73,0,0,0,4.52,0l.88-.09-.4.79a8,8,0,0,0-1,2.69l.1,0c1-.52,2.16-4.31,2.58-5.74.35-1.16.39-1.33.81-1.33l.37,0,.09.37c.06.25,0,.59-.33,1.55a14.16,14.16,0,0,0-.58,2.41c.36,0,1-.12,1.63-.21a47.72,47.72,0,0,1,6.24-.6v1a47.82,47.82,0,0,0-6.1.59,19.45,19.45,0,0,1-2,.24.66.66,0,0,1-.43-.15,5.37,5.37,0,0,1-1.86,2.75A1.25,1.25,0,0,1,129.61,233.76Zm-10-5.14a.56.56,0,0,0-.49.18c0,.09.06.32.46.55a1,1,0,0,0,.21.11,3.1,3.1,0,0,0,.76-.58A2.16,2.16,0,0,0,119.62,228.62Zm-3.43-2a1.09,1.09,0,0,0-.63.35A7.29,7.29,0,0,0,114,229.4a3.42,3.42,0,0,0,2.59-2,.53.53,0,0,0-.27-.67A.42.42,0,0,0,116.19,226.67Zm7.47,1.34a1.16,1.16,0,0,0,.81,1.12,1.31,1.31,0,0,0,.32-.29c0-.08.09-.16,0-.31A1.67,1.67,0,0,0,123.66,228Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.25,177.77h28a5.79,5.79,0,0,1,5.79,5.79v16.36a5.78,5.78,0,0,1-5.79,5.78h-5.48l4.6,9.1-8.5-9.1H335.25a5.78,5.78,0,0,1-5.79-5.78V183.56A5.79,5.79,0,0,1,335.25,177.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.25,177.77h28a5.79,5.79,0,0,1,5.79,5.79v16.36a5.78,5.78,0,0,1-5.79,5.78h-5.48l4.6,9.1-8.5-9.1H335.25a5.78,5.78,0,0,1-5.79-5.78V183.56A5.79,5.79,0,0,1,335.25,177.77Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340.93,
    cy: 192.38,
    r: 1.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.23,
    cy: 192.38,
    r: 1.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.33,192.38a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,359.33,192.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.27,245h-28a5.79,5.79,0,0,0-5.79,5.79v16.36a5.79,5.79,0,0,0,5.79,5.79h5.49l-4.6,9.09,8.49-9.09h18.59a5.79,5.79,0,0,0,5.79-5.79V250.75A5.79,5.79,0,0,0,193.27,245Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.27,245h-28a5.79,5.79,0,0,0-5.79,5.79v16.36a5.79,5.79,0,0,0,5.79,5.79h5.49l-4.6,9.09,8.49-9.09h18.59a5.79,5.79,0,0,0,5.79-5.79V250.75A5.79,5.79,0,0,0,193.27,245Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.59,
    cy: 259.57,
    r: 1.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.28,
    cy: 259.57,
    r: 1.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.98,
    cy: 259.57,
    r: 1.8,
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewteammembersRafiki);
export default __webpack_public_path__ + "static/media/New team members-rafiki.56c5b2548a49b169fbf4b284eed15b56.svg";
export { ForwardRef as ReactComponent };